import React from 'react'
import {
  createSocket,
  useSocketMessages,
  useHistory,
  useNotification,
  addMouseFlow,
} from '@orbital/games-frontend-library'

import { MessagesList } from './lib/texas_msg'
import { useEffect, useRef, useState } from 'react'
import {
  defaultStateRound,
  defaultGameInfo,
  defaultSeeds,
} from './lib/defaultValues'
import TexasHoldem from './texas/TexasHoldem'
import { useTexasSocketMessages } from './lib/texasSocketMessages'
import { useSettings } from './settings/useSettings'
import { setAudios, setStakes } from './settings/useSettings'

import { switchErrorCode } from './helpers/errorCodeHelper'
import { defaultStakes, defaultAudio } from './lib/defaultValues'
import { helperReceiveSettings } from './settings/receiveSettings'

const App = () => {
  const [gameInfo, setgameInfo] = useState(defaultGameInfo)

  const WS_URL = '{{SERVER_WS_URL}}'
  const name = 'orbital.texasholdem'
  const wsbridge = 'wsbridge/v1/game'

  const [stateRound, setStateRound] = useState(defaultStateRound)
  const [seeds, setSeeds] = useState(defaultSeeds)
  const [history, addInHistory] = useHistory(gameInfo.user_id)
  const [betReply, setBetReply] = useState({})

  const [notification, handleNotification, notificationfadeOut] =
    useNotification()

  const [errorCode, setErrorCode] = useState<number>(0)
  const [isError, setIsError] = useState<boolean>(false)

  const [errorText, setErrorText] = useState<string | false>(false)
  const handleErrorText = (text: string) =>
    setErrorText(errorText => (errorText ? errorText : text))

  const [stakesForSocket, setStakesForSocket] = useState(defaultStakes)
  const [audioForSocket, setSocketaudio] = useState(defaultAudio)

  const socket = useRef<any>(null)

  const receiveSettings = (obj: string) =>
    helperReceiveSettings(
      obj,
      setStakesForSocket,
      setSocketaudio,
      gameInfo.maxBet,
    )

  const [setStatus, receiveMessage, sendSocketMessage, sender] =
    useSocketMessages({
      socket,
      MessagesList,
      setStateRound,
      setgameInfo,
      addInHistory,
      setSeeds,
      handleErrorText,
      receiveSettings,
      setBetReply,
      handleNotification,
      setErrorCode,
    })

  switchErrorCode(errorCode, setIsError, setErrorCode) //TODO must test this

  useEffect(() => {
    if (!socket.current)
      createSocket(socket, receiveMessage, setStatus, WS_URL, name, wsbridge)
  }, [socket, receiveMessage, setStatus])

  const texasSocketMessages = useTexasSocketMessages(sendSocketMessage)

  const settingsFromSocket = useSettings(sendSocketMessage)

  useEffect(() => {
    setAudios(audioForSocket)
  }, [audioForSocket])

  useEffect(() => {
    setStakes(stakesForSocket.ante)
  }, [stakesForSocket])

  useEffect(() => addMouseFlow(), [])

  useEffect(() => {
    console.log('%cV2.0.2 DG', 'background: green; font-size: 16px')
  }, [])

  return (
    <TexasHoldem
      gameInfo={gameInfo}
      stateRound={stateRound}
      seeds={seeds}
      history={history}
      seedRequest={sender.seedRequest}
      newSeedRequest={sender.newSeedRequest}
      requestBetReply={sender.requestBetReply}
      handleNotification={handleNotification}
      texasSocketMessages={texasSocketMessages}
      stakesForSocket={stakesForSocket}
      isError={isError}
      errorText={errorText}
      notification={notification}
      notificationfadeOut={notificationfadeOut}
      betReply={betReply}
    />
  )
}

export default App
